module.exports = {
  "dof-refresher": {
    "height": "140",
    "width": "750",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "paddingTop": "50"
  },
  "cycle-container": {
    "position": "relative",
    "width": "60",
    "height": "60"
  },
  "u-cover": {
    "position": "absolute",
    "width": "30",
    "height": "60",
    "top": 0,
    "backgroundColor": "#ffffff",
    "overflow": "hidden",
    "right": 0
  },
  "c1": {
    "zIndex": 1
  },
  "c2": {
    "zIndex": 2,
    "transformOrigin": "left center",
    "transform": "rotateZ(0deg)"
  },
  "u-cover-cycle": {
    "position": "absolute",
    "width": "60",
    "height": "60",
    "right": 0,
    "top": 0,
    "borderWidth": "2",
    "borderColor": "#616c73",
    "borderStyle": "solid",
    "borderRadius": "30",
    "opacity": 0
  },
  "cover1": {
    "opacity": 1
  },
  "indicator": {
    "height": "35",
    "width": "35",
    "color": "#616c73"
  },
  "arrow-down": {
    "position": "relative",
    "top": "15",
    "left": "-45",
    "width": "30",
    "height": "30",
    "borderWidth": "1"
  },
  "u-txt": {
    "fontSize": "24",
    "lineHeight": "40",
    "color": "#8e969b",
    "marginTop": "10",
    "marginLeft": "10",
    "height": "40",
    "lines": 1
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-01843725!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-refresher/index.vue
// module id = 412
// module chunks = 0 1